import {AfterViewInit, ChangeDetectorRef, Component, ComponentFactoryResolver, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {GlobalQuestionService} from '../../services/global-question.service';
import {newGuid, parseOptions} from '../question-helper';
import { SlickCarouselComponent } from "ngx-slick-carousel";
import { QuestionFlowSessionQuery } from '../state/question-flow-session.query';
import { RouterLinks } from '../../constants';
import { Router } from '@angular/router';
import { ShoppingCartStore } from '../state/shopping-cart-store';
import { set } from 'lodash';
import { Subscription } from 'rxjs';
import { StorageService } from '../../services/storage.service';

declare var $: any;
declare function isElementInViewport(c: any, a: boolean): any;
declare function editModalGuides(): any;
declare function initReadMore(): any;
@Component({
    selector: 'app-question-super-traffic-cop',
    templateUrl: './question-super-traffic-cop.component.html',
    styleUrls: ['./question-super-traffic-cop.component.scss'],
    standalone: false
})

export class QuestionSuperTrafficCopComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() question: Question;
  @Input() readOnly = false;
  @Input() showLabel = true;
  @Input() labelText = '';
  @Input() placeHolderText = '';
  @Input() value = '';
  @Input() showToolTip = true;
  @Input() toolTipContent = 'To change this answer you need to restart or contact us';
  @Input() toolTipPlacement = 'bottom';
  @Input() isToolTipContentHtml = false;
  @Input() items: any[] = [];
  @Input() selectedOption: any;
  @Input() selectedLocation: any;
  @Output() questionAnswer = new EventEmitter();
  @Output() showEditModal = new EventEmitter<any>();
  @Output() locationExits = new EventEmitter<any>();
  @Output() enableButtonFromChild = new EventEmitter<any>();
  @Output() submit = new EventEmitter<void>();
  @Output() addLocation = new EventEmitter<void>();
  @Output() editLocation = new EventEmitter<any>();
  @ViewChild("slickModal") slickModal: SlickCarouselComponent;

  classes: any;
  grouping: any[] = [];
  nonLocation: any[] = [];
  uniqueControlName = `textbox-${newGuid()}`;
  uniqueId = `textbox-${newGuid()}`;
  slideConfig = {
    dots: true,
    arrows: false,
    variableWidth: false,
    infinite: false,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    swipeToSlide: true,
    prevArrow: '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="#right-small"></use></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="#right-small"></use></svg></button>',
    rows: 0,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          arrows: true,
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  };
  trafficConfig = {
    dots: true,
    arrows: true,
    fade: true,
    speed: 400,
    cssEase: "ease-in",
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    prevArrow: '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="#right-small"></use></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="#right-small"></use></svg></button>',
    rows: 0
  };
  session_details: any;
  classCount = 0;
  locations: any [] = [];
  // context: the one row of section toggles; profile: the "Your profile" rows. Their flags (and the addons_* flags
  // in item_detail) arrive as 1/0 or true/false depending on the column, so they are only tested for truthiness.
  context: any;
  profile: any[] = [];
  locationsTitle = 'Your Locations';
  // section icons: image_url of the first profile / location row. The icon both sections had before stands in when
  // the proc sends no row for the section, or no image_url on it.
  defaultSectionImage = 'assets/icn/products/profile.svg';
  profileImage = this.defaultSectionImage;
  locationsImage = this.defaultSectionImage;
  // the one switch for the accordion housing: true wraps the profile, locations and cover groups in accordion sections,
  // false lists the same cards flat. Set from code - it does not come from the proc.
  showAccordion = true;
  selectSection: any;
  selectedItem: any;
  removeModal: any;
  // what the open remove dialog removes once confirmed
  pendingRemove: () => void;
  summaryDataSubscription: Subscription;
  constructor(public questionService: GlobalQuestionService,
    private questionFlowSessionQuery: QuestionFlowSessionQuery,
    private shoppingCartStore: ShoppingCartStore,
    private ref: ChangeDetectorRef,
    private router: Router,
    private storageService: StorageService,
    ) {
    this.questionService.spinner(true);
    this.session_details = this.questionFlowSessionQuery.getValue();
  }
  
  ngOnInit(): void {
   this.getSuperTrafficCop();
    this.summaryDataSubscription = this.questionService.summaryData
      .subscribe(v => {
        if (v) {
          //if (!this.isSavingData) {
            this.getSuperTrafficCop();
          //}
          this.questionService.setSummaryDataObservable(false);
        }
      });
    
  }
  getSuperTrafficCop(): void{
    const parameters = new Map<string, string>();
    this.nonLocation = [];
    this.questionService.spinner(true);
    parameters.set('session_id', this.session_details?.session_id);
    //parameters.set('location_id', this.selectedOption?.location_id?.toString());
    this.questionService.runCommandNew(`getSuperTrafficCop`, parameters, true)
      .subscribe(datasets => {
        // Four result sets: the cover cards, the context row, the profile rows and the location rows. The last three
        // are fail-safe in the proc, so any of them can be missing - they are picked out by shape, not by position.
        const classes: any[] = datasets?.[0] ?? [];
        const extras: any[][] = datasets?.slice(1) ?? [];
        this.profile = extras.find(d => d?.[0]?.entry_type !== undefined) ?? [];
        this.profileImage = this.profile[0]?.image_url || this.defaultSectionImage;
        // the location rows are only read for their icon - the locations listed still come off the cover cards
        this.locationsImage = extras.find(d => d?.[0]?.location_id !== undefined)?.[0]?.image_url || this.defaultSectionImage;
        this.classes = classes;
        console.log(this.classes);
        this.classCount = this.classes.filter(c => c.group_id > 0).length;
        if (this.classCount === 1) {
          //$('#next-question-label').text('Next');
          this.showAccordion = false;
        }
        this.items = classes;

        // rebuilt on every load so a removed location drops out
        const locations = [];
        this.items.forEach(i => {
          if (i?.item_detail !== '') {
            i.item_detail = JSON.parse(i?.item_detail);
          }
          if (this.grouping.filter(g => g.group_id === i.group_id).length === 0 && i.group_id !== 4 && i.cent_aq_answer_id !== 0) {
            this.grouping.push(i);
          }
          if (locations.filter(l => l.location_id === i.location_id).length === 0 && i.location_id !== 0) {
            locations.push({ location_id: i.location_id, location_name: i.location_name, address: this.formatAddress(i.location_address) });
          }
        });
        this.locations = locations;
        // no context row (older proc, or the section failed): fall back to the proc's own defaults - profile on,
        // locations on for a journey that has them
        this.context = extras.find(d => d?.[0]?.show_policyholder !== undefined)?.[0]
          ?? { show_policyholder: 1, show_locations: locations.length > 0 ? 1 : 0, show_existing_locations: 1 };
        // the business name only comes through as the profile row labelled 'Insured entity'
        const business = this.profile.find(p => p?.role_label === 'Insured entity')?.name;
        this.locationsTitle = business ? `${business}’s Locations` : 'Your Locations';
        this.nonLocation = this.items.filter(i => i.group_id === 4);
        
        if (this.locations?.length > 0) {
          this.locationExits.emit({ locations: this.locations, classes: this.classes, grouping: this.grouping, nonlocation: this.nonLocation });
          //Handle location modal logic
          let loc = { session_id: '', locationModalShown: false };
          try {
            loc = this.storageService.getJson('locationModalShown', 'flow')
          }
          catch { }
          if (!loc) {
            $('#splash-modal').modal('show');
            loc = { session_id: this.session_details?.session_id, locationModalShown: true };
            this.storageService.setJson('locationModalShown', loc, 'flow');
          }
          else {
            if (loc?.session_id !== this.session_details?.session_id && loc?.locationModalShown === false) {
              $('#splash-modal').modal('show');
              loc.session_id = this.session_details?.session_id;
              loc.locationModalShown = true;
              this.storageService.setJson('locationModalShown', loc, 'flow');
            }
          }
        }
        this.checkIfItemExists();
        setTimeout(() => {
          this.questionService.spinner(false);
          //this.initCoverSlider();
          initReadMore();
          let disabled = this.items.find(i => i.group_id == null)?.disabled;
    
          this.enableButtonFromChild.emit(disabled == 1)
        }, 2000);
      });
  }
  // location_address is the address answer's JSON blob; gps and province are held for lookups, not for display
  formatAddress(address: string): string {
    let parts: any;
    try {
      parts = JSON.parse(address);
    } catch {
      return address ?? '';
    }
    return [parts?.apartmentNo, parts?.complex, parts?.streetAddress, parts?.suburb, parts?.city, parts?.postalCode]
      .filter(part => part !== null && part !== undefined && String(part).trim() !== '')
      .join(', ');
  }
  filterClassByLocation(): void {
    this.items = this.classes?.filter(i => i.location_id === this.selectedLocation?.location_id);

    this.locationExits.emit({ locations: this.locations, classes: this.items, grouping: this.grouping, nonlocation: this.nonLocation });
  }
  ngOnChanges(changes: SimpleChanges): void {

    if (changes?.question?.currentValue !== changes?.question?.previousValue) {
      this.question = changes?.question?.currentValue;
      this.items = parseOptions(this.question?.options);
    } else if (changes?.items?.currentValue) {
      this.items = changes?.items?.currentValue;
    }
    if (changes?.showLabel?.currentValue !== changes?.showLabel?.previousValue) {
      this.showLabel = changes?.showLabel?.currentValue;
    }
    if (changes?.readOnly?.currentValue !== changes?.readOnly?.previousValue) {
      this.readOnly = changes?.readOnly?.currentValue;
    }
    if (changes?.selectedOption?.currentValue !== changes?.selectedOption?.previousValue) {
      this.selectedOption = changes?.selectedOption?.currentValue;
    }
    if (changes?.selectedLocation?.currentValue !== changes?.selectedLocation?.previousValue) {
      this.selectedLocation = changes?.selectedLocation?.currentValue;
    }

    this.filterClassByLocation();
    setTimeout(() => {
      this.questionService.setShoppingCart(this.question);
    }, 2000);
  }
  addAnother(c: any): void {
    this.question.answer = c.answer;
    $('#next-question-label').text('Next');
    this.questionAnswer.emit(this.question);
    this.submit.emit();
    setTimeout(() => {
      // this.question.answer = 'Nothing More';
      // this.questionAnswer.emit(this.question);
       $('#next-question-label').text('View quote summary');
    }, 5000);
  }
  // "Add" on a cover card: select the cover (as the old radio did) and go straight into its questions
  addCover(c: any): void {
    this.question.location_id = c.location_id;
    this.selectedOption = c;
    this.addAnother(c);
  }
  // cover the proc has disabled and that has nothing added yet - its card shows the Locked badge. Mostly dependent cover
  // waiting for the cover it depends on, but cover without a parent can be locked too (Professional: Employers Liability)
  isLocked(c: any): boolean {
    return c?.disabled === 1 && c?.included !== 1 && !c?.item_detail && c?.del !== 1 && c?.edit !== 1;
  }
  // "Read more" only shows while the description is clamped (or already revealed)
  canReveal(c: any, content: HTMLElement): boolean {
    return !!c?._revealed || content.scrollHeight > content.clientHeight;
  }
  checkRadio(level: any, event): void {
    if (this.classCount === 1) {
      $('#next-question-label').text('Next');
      return;
    }
    $('.custom-traffic').removeClass('is-checked');

    if ($(`.${level.cent_aq_answer_id}`).hasClass('is-checked')) {
      $('.custom-traffic:not(".is-included"):not(".is-active")')
        .removeClass('is-checked')

        // and uncheck any groups
        .closest('.custom-traffic__group')
        .removeClass('is-checked');
      $(`.${level.cent_aq_answer_id}`).removeClass('is-checked');
      if (this.question) {
        //this.question.answer = 'Nothing More';
        //this.questionAnswer.emit(this.question);
        $('#next-question-label').text('View quote summary');
      } else {
        this.questionAnswer.emit(level.answer);
      }
    }
    else {

      $(`.${level.cent_aq_answer_id}`).addClass('is-checked');
      if (this.question) {
        this.question.answer = level.answer;
        this.question.location_id = level.location_id;
        this.questionAnswer.emit(this.question);
        $('#next-question-label').text('Next');
      } else {
        this.questionAnswer.emit(level.answer);
      }
    }
    if (event) {
      if (event?.srcElement?.checked) {
        this.question.answer = level.answer;
        this.questionAnswer.emit(this.question);
        $('#next-question-label').text('Next');
      }
      else {
        //this.question.answer = 'Nothing More';
        //this.questionAnswer.emit(this.question);
        $('#next-question-label').text('View quote summary');
      }
    }
    console.log(level);
    this.selectedOption = level;
    this.checkIfItemExists();

  }
  ngAfterViewInit(): void {
    $("#splash-modal").on("hidden.bs.modal", () => {
      // the tour's tips hang off the accordion housing (tip 3 sits on the first group, the check below reads
      // #traffic-locations), so it only runs with the housing on
      if (!this.showAccordion) {
        return;
      }
      // the first tip sits on the Locations card, so bring it into view before starting the tour (as the prototype does)
      const $tip = $('#guide-1-tip-1');
      if ($(window).width() < 768 || !$tip.length || isElementInViewport($('#traffic-locations'), false)) {
        editModalGuides()?.init(null, 1);
        return;
      }
      setTimeout(() => {
        $('html, body').animate({ scrollTop: $tip.offset().top - 200 }, 500).promise().then(() => editModalGuides()?.init(null, 1));
      }, 1000);
    });
    $('#page-canvas').removeClass('quote-progress-active');

  }
  getGroupingClasses(group: any, c: any): any {
    
    if (this.classCount === 1) {
      return this.items.filter(g => g.group_id === group.group_id && g.group_id !== 4 && g?.level === 1);
    }
    else {
      if (c) return this.items.filter(g => g.group_id === group.group_id && g.group_id !== 4 && g.parent_answer_id === c.cent_aq_answer_id && g.location_id === this.selectedLocation?.location_id);
      else if (this.selectedLocation){
          return this.items.filter(g => g.group_id === group.group_id && g.group_id !== 4 && g.location_id === this.selectedLocation?.location_id && g?.level === 1);
      } 
      else 
        return this.items.filter(g => g.group_id === group.group_id && g.group_id !== 4  && g?.level === 1);
    }
  }
  getItk(l: any): any {
    if (!l) return [];
    if (l._itkParsed !== undefined) {
      return l._itkParsed;
    }
    try {
      l._itkParsed = JSON.parse(l.itk);
    }
    catch {
      l._itkParsed = [];
    }
    return l._itkParsed;
  }
  // itk copy as plain strings for app-itk
  getItkItems(l: any): string[] {
    if (!l) return [];
    if (l._itkItems === undefined) {
      l._itkItems = (this.getItk(l) || []).map(i => i?.info_comment).filter(t => !!t);
    }
    return l._itkItems;
  }
  upperCase(): void {
    if (this.question?.cent_aq_question_id === 57 || this.question?.cent_aq_question_id === 2501) {
      this.value = this.value.toUpperCase();
    }
  }

  saveValue(): void {
    if (this.question) {
      this.question.answer = this.value;
      this.questionAnswer.emit(this.question);
    } else {
      this.questionAnswer.emit(this.value);
    }
  }
  initCoverSlider(): void {
    var $slider = $("#cover-slider");
    
    if ($slider.length === 0) {
      console.warn("#cover-slider not found when initializing slider");
      return;
    }
    
    // If already initialized, destroy it first
    if ($slider.hasClass("slick-initialized")) {
      $slider.slick("unslick");
      $('.slick-container').slick('removeSlide', null, null, true);
    }
    else {
      
      $slider.slick({
        dots: true,
        arrows: false,
        variableWidth: false,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        prevArrow: '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="#right-small"></use></svg></button>',
        nextArrow: '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="#right-small"></use></svg></button>',
        rows: 0,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              arrows: true,
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
  }
  initSliders(): void {
         var accordionsOpen = false;
      // only listen for non-included and non-activated controls
      $(document).on('click', '.custom-traffic:not(".is-included"):not(".is-active") .custom-traffic__label', function(){
         
         var $controlLabel = $(this);
         var $control = $controlLabel.closest('.custom-traffic');
         var $controlGroup = $control.closest('.custom-traffic__group');
      
         // if not already checked
         // and if no active controls of the same name exist
         if( !$control.hasClass('is-checked') ){

            // find other controls, and uncheck 'em all 
            $('.custom-traffic:not(".is-included"):not(".is-active")')
               .removeClass('is-checked')

               // and uncheck any groups
               .closest('.custom-traffic__group')
               .removeClass('is-checked');

            // check control
            $control.addClass('is-checked');

            // and check active group if exists
            if($controlGroup){
               $controlGroup.addClass('is-checked');
            }

         } else {

            // uncheck control
            $control.removeClass('is-checked');

            // and and uncheck group if exists
            if($controlGroup){
               $controlGroup.removeClass('is-checked');
            }

         }         

      });
    
      // on remove of active item...
      // convert to standard state
      var $itemToDeactivate = null;            

      // $('#remove-alert-modal').on('show.bs.modal', function(e){
      //    var $trigger = $(e.relatedTarget);
      //    $itemToDeactivate = $trigger.closest('.custom-traffic');
      // });

      // $(document).on('click', '#remove-cover-btn', function(e){       
      //    $itemToDeactivate
      //       .removeClass('is-active')
      //       .find('.custom-traffic__indi').html('<span class="fake-radio"></span>');

      //    $itemToDeactivate.closest('.custom-traffic__group')
      //       .removeClass('is-active').removeClass('is-checked')
      //       .find('.custom-traffic--child').removeClass('is-active').removeClass('is-checked');            
      // });
      

      // sliders
    //   $('.slider--traffic').each(function () {
    //     var $slider = $(this);

    //     $slider.slick({
    //        dots: true,
    //        arrows: true,
    //        fade: true,
    //        speed: 400,
    //        cssEase: "ease-in",
    //        infinite: false,
    //        slidesToShow: 1,
    //        slidesToScroll: 1,
    //        swipeToSlide: true,
    //        prevArrow: '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="#right-small"></use></svg></button>',
    //        nextArrow: '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="#right-small"></use></svg></button>',
    //        rows: 0
    //     });

    //     // // carousel refresh on accordion open (else it's all broken-like ...probably fine when using angular version tho)
    //     // $slider.closest('.accordion__body').on('show.bs.collapse', function (e) {
    //     //    // $slider.slick('refresh'); 
    //     // });


    //  });
   
  }
  reloadQuestion(q:any): void {
    this.grouping = [];
    this.question = q;
    this.items = parseOptions(q?.options);
    setTimeout(() => {
      //this.questionAnswer.emit(q);
    }, 5000);
    
    //this.ngOnInit();
    //window.location.reload();
    //this.questionAnswer.emit(this.question);
    // this.items.forEach(i => {
    //   if (!this.grouping.includes(i.group_name))
    //     this.grouping.push(i.group_name);
    // });
  }

  // Edit on a profile entry opens the same edit modal as a cover item, on its General section - the business name
  // behind the policyholder row is answered there. Which entries get the button is up to the proc's edit flag.
  editProfile(): void {
    this.editModal(null);
  }
  editModal(event: any, item_id = 1): void {
    if (item_id === 0) item_id = 1;
    if (event) {
      event.item_id = item_id;
    }
    console.log(event);
    this.questionService.spinner(true);
    let collation: any;
      this.questionService.updatePrices(this.question?.product_id, this.question?.product_class_id, 0)
        .subscribe(x => {
          this.questionService.getPageData('quote')
            .subscribe(dataset => {
              console.log(dataset);
              let product = this.questionService.getIndexData(4, dataset).find(p => p.product_id === this.question?.product_id);              
              let person = this.questionService.getIndexData(1, dataset)[0];
              let collations = this.questionService.getIndexData(2, dataset);
              let locations = this.questionService.getIndexData(15, dataset);

              // no cover (profile Edit) means no collation, which the modal opens on its General section
              collation = event ? collations.find(c => c.class_id === event?.class_id && c.session_item_id.toString() === event?.item_id.toString() && c.product_id === product?.product_id) : null;
              console.log('item', event);
              console.log('product', product);
              console.log('collation', collation);
              console.log('collations', collations);

              this.showEditModal.emit({
                collations: collations,
                collation,
                product: product,
                person: person,
                locations: locations,
                path: '3'
              });
            }, error => {
              console.log(error);
              this.questionService.spinner(false);
            });
        }, () => {
          this.questionService.spinner(false);
        });
    
  }
  checkIfItemExists(): void {
    this.enableButtonFromChild.emit(true);
    let itemExists = false;
    this.items.forEach(item => {
      if (item?.item_detail){
        itemExists = true;
      }
    });
    if (itemExists || this.question.answer){
      this.enableButtonFromChild.emit(false);
    }
    else if (!itemExists && !this.question.answer){
      this.enableButtonFromChild.emit(true);
    }
    else if (itemExists || !this.question.answer){
      this.question.answer = this.selectedOption?.answer
      this.questionAnswer.emit(this.question);
      this.enableButtonFromChild.emit(false);
    }
    
  }
  hasItems(group: any): boolean {
    if ( this.items.filter(g => g.group_id === group.group_id && g.item_detail?.length > 0 && g.location_id === this.selectedLocation?.location_id)?.length > 0){
      return true;
    }
    else {
      return false;
    }
  }
  // Remove on a cover item. Cover that sends remove_modal copy (what else goes with it) asks first.
  // The item's own remove_modal (names the item) wins over the cover's.
  removeCover(c: any, i: string, item?: any): void {
    let copy: any[] = [];
    try {
      // cover.remove_modal is a JSON string; an item's own remove_modal arrives already parsed
      const raw = item?.remove_modal ?? c?.remove_modal;
      copy = (typeof raw === 'string' ? JSON.parse(raw) : raw) ?? [];
    } catch { }
    if (copy.length > 0) {
      this.confirmRemove(copy, () => this.removeClassItem(c, i));
    } else {
      this.removeClassItem(c, i);
    }
  }
  askRemoveLocation(location: any): void {
    this.confirmRemove([{ value: `Are you sure you want to remove ${location?.location_name}?` }, { value: '' }],
      () => this.removeLocation(location));
  }
  // copy has the remove_modal shape: [header, body]
  confirmRemove(copy: any[], remove: () => void): void {
    this.removeModal = copy;
    this.pendingRemove = remove;
    // the dialog is only in the DOM once removeModal is set
    this.ref.detectChanges();
    (document.getElementById('remove-section-modal') as HTMLDialogElement)?.showModal();
  }
  removeConfirmed(): void {
    this.pendingRemove?.();
    this.pendingRemove = null;
  }
  removeClassItem(c: any, i: string): void {
    console.log(c, i);
    const parameters = new Map<string, string>();
    parameters.set('session_id', this.session_details?.session_id);
    parameters.set('class_id', c.class_id);
    parameters.set('item_id', i);
    parameters.set('location_id', c?.location_id?.toString());
    this.questionService.runCommandNew(`removeClassItem`, parameters)
      .subscribe(response => {
        this.getSuperTrafficCop();
        setTimeout(() => {
          this.questionService.setShoppingCart(this.question);
        }, 1000);
      })
  }
  removeLocation(location: any): void {
    const parameters = new Map<string, string>();
    parameters.set('session_id', this.session_details?.session_id);
    // a location's own answers are saved with item_id = location_id
    parameters.set('item_id', location?.location_id?.toString());
    parameters.set('location_id', location?.location_id?.toString());
    this.questionService.runCommandNew(`removeLocation`, parameters)
      .subscribe(() => {
        this.getSuperTrafficCop();
        setTimeout(() => {
          this.questionService.setShoppingCart(this.question);
        }, 1000);
      });
  }
  nothinMore(event: any): void {
    console.log(event)
  }
}
